(() => {
  const endpoint = "https://ideal-reviews.thriftyscot.co.uk/api/reviews?limit=1";
  const getSummary = () => {
    window.__idealReviewsSummaryPromise ||= fetch(endpoint, { headers: { Accept: "application/json" } })
      .then((response) => {
        if (!response.ok) throw new Error(`Ideal Reviews returned ${response.status}`);
        return response.json();
      })
      .then((result) => result.summary);
    return window.__idealReviewsSummaryPromise;
  };
  const formatCount = (value, rounding) => {
    const unit = rounding === "thousand" ? 1000 : rounding === "hundred" ? 100 : 1;
    const displayed = unit === 1 ? value : Math.floor(value / unit) * unit;
    return `${displayed.toLocaleString("en-GB")}${displayed < value ? "+" : ""}`;
  };
  const initialise = async (root = document) => {
    const badges = [...root.querySelectorAll("[data-ideal-review-badge]:not([data-ideal-review-ready])")];
    if (!badges.length) return;
    try {
      const summary = await getSummary();
      badges.forEach((badge) => {
        const metric = badge.dataset.metric;
        const suffix = badge.dataset.suffix?.trim() || "reviews";
        let figure;
        if (metric === "average") figure = Number(summary.averageRating).toFixed(1);
        else {
          const value = metric === "five_star" ? Number(summary.distribution?.[5] || 0) : Number(summary.total || 0);
          figure = formatCount(value, badge.dataset.rounding);
        }
        badge.textContent = `${figure} ${suffix}`;
        badge.dataset.idealReviewReady = "true";
      });
    } catch {
      // Keep the merchant's saved fallback title if the service is unavailable.
    }
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initialise(), { once: true });
  else initialise();
  document.addEventListener("shopify:section:load", (event) => initialise(event.target));
})();
